import React from "react";
import StatusBadge from "@/components/StatusBadge";

function fmt(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: "Asia/Kolkata" });
  } catch { return ""; }
}

export default function StatusTimeline({ history }) {
  const items = [...(history || [])].reverse();
  if (!items.length) return <p className="text-sm text-muted-foreground">No history yet.</p>;
  return (
    <div className="space-y-0" data-testid="status-timeline">
      {items.map((h, idx) => (
        <div key={`${h.at || ""}-${h.status || ""}-${h.note || ""}-${idx}`} className="flex gap-3 pb-4 relative">
          <div className="flex flex-col items-center">
            <div className="h-3 w-3 rounded-full bg-[#0B3D3D] mt-1.5" />
            {idx < items.length - 1 && <div className="w-px flex-1 bg-border" />}
          </div>
          <div className="flex-1 -mt-0.5">
            <div className="flex items-center gap-2 flex-wrap">
              {h.status && <StatusBadge status={h.status} />}
              <span className="text-xs text-muted-foreground">{fmt(h.at)}</span>
            </div>
            <p className="text-sm text-[#111411] mt-1">
              {h.note ? h.note : "Updated"}
              {h.by_name && <span className="text-muted-foreground"> · by {h.by_name}</span>}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
